module.exports = __webpack_public_path__ + "mobile/img/ipswitch-img1.4b0128f4.png";